import TemplateViewer from '../../Template-Management/Template-Viewer/template-viewer';
import { useState } from 'react';

export default function ViewModal({
  contract,
  content,
  setContent,
  onClose,
  onSave,
  isBlank,
  isEdit,
}) {
  const [modal, setModal] = useState(null);
  console.log('🚀 ~ file: view-modal.js:10 ~ViewModal ~ contract:', contract);
  console.log('🚀 ~ file: view-modal.js:10 ~ ViewModal ~ content:', content);

  return (
    <Modal
      title={contract?.title || 'Contract Viewer'}
      className="max-w-6xl"
      onClose={() => onClose()}
    >
      <div className="  text-sm text-gray-700 leading-relaxed whitespace-pre-line">
        <TemplateViewer contract={contract.document_content} />
      </div>
    </Modal>
  );
}

function Modal({ title, children, onClose, className = '' }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div
        className={`
          bg-white rounded-xl shadow-xl w-full max-w-4xl h-[80vh] flex flex-col
          ${className}
        `}
      >
        {/* Header (fixed) */}
        <div className="flex justify-between items-center p-4 border-b shrink-0">
          <h2 className="font-semibold">{title}</h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Body (scrollable) */}
        <div className="p-4 flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
